export default "__VITE_ASSET__pMiNiP3J__"